// One confirm dialog for every platform: the native alert on phones, and on web the in-page dialog that
// src/ui/webAlert.tsx puts behind Alert.alert (react-native-web ships Alert as a stub that does nothing).
import { Alert } from 'react-native';

/** Same dialog for a non-destructive choice (plain confirm button). */
export function confirmAction(title: string, message: string, confirmLabel: string, onConfirm: () => void) {
  Alert.alert(title, message, [{ text: 'Cancel', style: 'cancel' }, { text: confirmLabel, onPress: onConfirm }]);
}

export function confirmDestructive(title: string, message: string, confirmLabel: string, onConfirm: () => void) {
  Alert.alert(title, message, [
    { text: 'Cancel', style: 'cancel' },
    { text: confirmLabel, style: 'destructive', onPress: onConfirm },
  ]);
}
